import Vue from 'vue'
import Vuex from 'vuex'
import { distanceInWordsToNow } from 'date-fns'
import i18n from '../i18n'

Vue.use(Vuex)

// auto load locales for date-fns
const locales = i18n.availableLocales.reduce((map, lang) => {
  map[lang] = require('date-fns/locale/' + lang + '/index.js')
  return map
}, {})

const initialState = {
  locale: i18n.locale
}

const getters = {
  locale: state => state.locale,
  getDateFromNow: state => date => distanceInWordsToNow(date, { locale: locales[state.locale] })
}

const mutations = {
  updateLocale(state, newLocale) {
    state.locale = newLocale
  }
}

const actions = {
  changeLocale({ commit }, newLocale) {
    // update locale for all app
    i18n.locale = newLocale
    // store selected locale in browser for later
    localStorage.setItem('locale', newLocale)
    commit('updateLocale', newLocale)
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
